<h1 mat-dialog-title>Create support ticket</h1>
<div mat-dialog-content>
    <p class="intro">Tell the LINQ support team what you need. They'll reply by email{{email ? ' to ' + email : ''}}.</p>
    @if (restoredDraft) {
        <p class="draft">Your unsent ticket has been restored. <button mat-button color="accent" type="button" (click)="clearDraft()">Start again</button></p>
    }
    <form [formGroup]="ticketForm">
        <div class="row">
            <mat-form-field>
                <mat-label>Type</mat-label>
                <mat-select formControlName="type" [errorStateMatcher]="matcher" required>
                    @for (type of types; track type.value) {
                        <mat-option [value]="type.value">{{type.value}}</mat-option>
                    }
                </mat-select>
                <mat-hint>{{getTypeHint()}}</mat-hint>
                @if (ticketForm.controls['type'].hasError('required')) {
                    <mat-error>Choose a ticket type</mat-error>
                }
            </mat-form-field>
            <mat-form-field>
                <mat-label>Priority</mat-label>
                <mat-select formControlName="priority" [errorStateMatcher]="matcher" required>
                    @for (priority of priorities; track priority.value) {
                        <mat-option [value]="priority.value">{{getPriorityName(priority.value)}}</mat-option>
                    }
                </mat-select>
                <mat-hint>{{getPriorityHint()}}</mat-hint>
                @if (ticketForm.controls['priority'].hasError('required')) {
                    <mat-error>Choose a priority</mat-error>
                }
            </mat-form-field>
        </div>

        <mat-form-field class="full">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject" id="subject" type="text" [errorStateMatcher]="matcher" [maxlength]="TICKET_SUBJECT_MAX" placeholder="A short summary" required>
            <mat-hint align="end">{{ticketForm.value.subject?.length || 0}}/{{TICKET_SUBJECT_MAX}}</mat-hint>
            @if (ticketForm.controls['subject'].hasError('required')) {
                <mat-error>Subject is <strong>required</strong></mat-error>
            }@else if (ticketForm.controls['subject'].invalid) {
                <mat-error>{{getSubjectError()}}</mat-error>
            }
        </mat-form-field>
        <mat-form-field class="full">
            <mat-label>Description</mat-label>
            <textarea matInput
                formControlName="description"
                cdkTextareaAutosize
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="14"
                [maxlength]="TICKET_DESCRIPTION_MAX"
                placeholder="What happened, what you expected, and the model or page you were on"
                [errorStateMatcher]="matcher"
                required></textarea>
            <mat-hint align="end">{{ticketForm.value.description?.length || 0}}/{{TICKET_DESCRIPTION_MAX}}</mat-hint>
            @if (ticketForm.controls['description'].hasError('required')) {
                <mat-error>Description is <strong>required</strong></mat-error>
            }@else if (ticketForm.controls['description'].invalid) {
                <mat-error>{{getDescriptionError()}}</mat-error>
            }
        </mat-form-field>
        <mat-checkbox formControlName="includeContext" class="context-toggle">Include the page, LINQ version and browser, to help support</mat-checkbox>
        @if (ticketForm.value.includeContext) {
            <pre class="context">{{context}}</pre>
        }
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancelClick()">Cancel</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="save()">Send ticket</button>
</div>
